import { combineReducers } from "redux";
import createEntity from "./newEntity";
import createObject from "./newObject";
import postcode from './newPostcode';

const newEntity = combineReducers({
  createEntity,
  createObject,
  postcode,
});

export default newEntity;
